'use client';

/**
 * Footer link that re-opens the cookie consent banner.
 * Dispatches a custom event that CookieConsent listens for.
 */
export default function CookiePreferencesLink() {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent('castlopedia:open-consent'));
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="text-gray-400 hover:text-white transition-colors duration-200 text-sm text-left"
    >
      Cookie preferences
    </button>
  );
}
